import styled from 'styled-components'
import { media } from '../../../utils'

export const Grid = styled.div`
  display: grid;
  grid-template-areas:
    '. info info info .'
    '. planning planning sidebar .'
    '. footer footer sidebar .';
  grid-template-columns: 1fr 380px 380px minmax(150px, 380px) 1fr;
  grid-template-rows: minmax(200px, auto) auto auto;
  grid-gap: 30px;
  padding-top: 133px;

  ${media.giant`
    grid-template-areas:
      '. planning .'
      '. footer .';
    grid-template-columns: 15px 1fr 15px;
    grid-template-rows: auto auto;
    grid-gap: 15px;
    padding-top: 118px;
  `}
  ${media.desktop`
    padding-top: 83px;
  `}
`

export const GridAdmin = styled.div`
  display: grid;
  grid-template-areas:
    '. planning planning planning .'
    '. products products products .'
    '. footer footer footer .';
  grid-template-columns: 1fr 380px 380px minmax(150px, 380px) 1fr;
  grid-template-rows: minmax(200px, auto) auto auto;
  grid-gap: 30px;
  padding-top: 133px;

  ${media.giant`
    grid-template-areas:
      '. planning .'
      '. products .'
      '. footer .';
    grid-template-columns: 15px 1fr 15px;
    grid-template-rows: auto auto;
    grid-gap: 15px;
    padding-top: 118px;
  `}
  ${media.desktop`
    padding-top: 83px;
  `}
`

export const ClientDetails = styled.div`
  grid-area: info;
  display: flex;
  justify-content: space-around;
  align-items: baseline;
  flex-wrap: wrap;
  padding: 60px 0 30px 0;
  overflow: hidden;
  ${media.desktop`justify-content: start;`}
`

export const Planning = styled.div`
  grid-area: planning;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  & > div {
    width: 100%;
  }
`

export const Overview = styled.div`
  grid-area: sidebar;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  overflow: hidden;

  & > div {
    width: 100%;
  }

  ${media.giant`
    grid-area: footer;
  `}
`



// WEBPACK FOOTER //
// ./src/components/containers/configurator/ScreenLayout.tsx